import {SUBSCRIPTION_STATUSES} from '../constants';

// see
// https://help.chargify.com/subscriptions/subscription-states.html

/**
 * Returns true if the status ID corresponds to a live status
 * @param {String} id 
 */
export const isLiveStatus = id => {
  switch(id) {
    case SUBSCRIPTION_STATUSES.TRIALING:
    case SUBSCRIPTION_STATUSES.ASSESSING:
    case SUBSCRIPTION_STATUSES.PENDING:
    case SUBSCRIPTION_STATUSES.PAUSED:
    case SUBSCRIPTION_STATUSES.ACTIVE:
      return true;
    default:
      return false;
  }
}

/**
 * Returns true if the status ID corresponds to a "problem" status
 * Problem status still means the subscription is active
 * @param {String} id 
 */
export const isProblemStatus = id => {
  switch(id) {
    case SUBSCRIPTION_STATUSES.SOFT_FAILURE:
    case SUBSCRIPTION_STATUSES.PAST_DUE:
    case SUBSCRIPTION_STATUSES.UNPAID:
      return true;
    default:
      return false;
  }
}

/**
 * Returns true if the status ID is an end of life status
 * EOL statuses mean the subscription is not active anymore
 * @param {String} id 
 */
export const isEndOfLifeStatus = id => {
  switch(id) {
    case SUBSCRIPTION_STATUSES.CANCELED:
    case SUBSCRIPTION_STATUSES.EXPIRED:
    case SUBSCRIPTION_STATUSES.SUSPENDED:
    case SUBSCRIPTION_STATUSES.TRIAL_ENDED:
    case SUBSCRIPTION_STATUSES.FAILED_TO_CREATE:
    case SUBSCRIPTION_STATUSES.ON_HOLD:
      return true;
    default:
      return false;
  }
}

/**
 * Returns true if the status ID is a trial only status
 * Meaning the subscription never went into "active" status (never paid)
 * @param {String} id 
 */
export const isTrialStatus = id => {
  switch(id) {
    case SUBSCRIPTION_STATUSES.TRIAL_ENDED:
    case SUBSCRIPTION_STATUSES.TRIALING:
      return true;
    default:
      return false;
  }
}

/**
 * Returns true if the status ID corresponds to a reactivable subscription
 * @param {String} id 
 */
export const isReactivableStatus = id => {
  switch(id) {
    case SUBSCRIPTION_STATUSES.CANCELED:
      return true;
    default:
      return false;
  }
}

/**
 * Returns true if the status ID corresponds to a cancellable subscription
 * @param {String} id 
 */
export const isCancellableStatus = id => {
  switch(id) {
    case SUBSCRIPTION_STATUSES.TRIALING:
    case SUBSCRIPTION_STATUSES.TRIAL_ENDED:
      return false;
    default:
      return true;
  }
}

/**
 * Returns true if the selected plan + licencesCount are valid
 */
export const isValid = (plan, licencesCount) => {
  return !!(plan 
    && plan.id 
    && !isNaN(licencesCount)
    && licencesCount > 0
    && (licencesCount >= plan.licencesCount || !plan.licencesCount)
  ); 
}


// WEBPACK FOOTER //
// ./src/helpers/subscription.js